import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const LOGO_URL = "https://customer-assets-39nsmqrw.emergentagent.net/job_lbm-portal/artifacts/lnqfvdo7_FB_IMG_1786087901927.jpg";
export const DEFAULT_AVATAR = "https://static.prod-images.emergentagent.com/jobs/6bc49e02-d81a-45b7-b150-f5737c9d679b/images/5ffc1a5b92dc3372791e6e9b1220b8a8bf1a6a7e38c5aa8113b5c074c4a3b978.jpeg";

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lbm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
